import IconProps from "./types";


const CheveronUpIcon = ({ ...others }: IconProps) => {
    return (
        <svg
            width="20" height="21" viewBox="0 0 20 21" fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...others}
        >
            <path d="M15 13L10 8L5 13" stroke={others.color ?? "#F67F00"} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}


export default CheveronUpIcon